export default "__VITE_ASSET__CwraNHrt__"